import { SchemaOf, object } from 'yup';
import { selectSchema } from './BaseSchemas';
import { AddTeamToProposal } from 'Models/TeamModels';

export const AddTeamToProposalSchema: SchemaOf<AddTeamToProposal> = object({
	proposalId: selectSchema('Proposal', 1),
	teamId: selectSchema('Team', 1),
});
